import * as v from "valibot";

import { rpcContract } from "../rpc";

export const publicProfileDataRpcContract = rpcContract({
  name: "publicProfileData",
  paramsSchema: v.object({
    handle: v.pipe(v.string(), v.minLength(3), v.maxLength(64), v.regex(/^[a-z0-9_\-.]+$/)),
  }),
  resultSchema: v.object({
    influencerId: v.string(),
    name: v.string(),
    handle: v.optional(
      v.union([v.literal(""), v.pipe(v.string(), v.minLength(3), v.maxLength(64), v.regex(/^[a-z0-9_\-.]+$/))]),
    ),
    bio: v.nullable(v.string()),
    profileImageUrl: v.nullable(v.string()),
    backgroundImageUrl: v.nullable(v.string()),
    backgroundImageMimeType: v.nullable(v.string()),
    socialLinks: v.array(v.string()),
    primaryColor: v.nullable(v.string()),
    secondaryColor: v.nullable(v.string()),
    colors: v.array(
      v.object({
        id: v.string(),
        primary: v.string(),
        secondary: v.string(),
      }),
    ),
    theme: v.nullable(
      v.object({
        id: v.string(),
        primaryColor: v.string(),
        secondaryColor: v.string(),
        primaryColorHover: v.string(),
        secondaryColorHover: v.string(),
        primaryColorPressed: v.string(),
        secondaryColorPressed: v.string(),
        isDefault: v.boolean(),
      }),
    ),
    customColors: v.nullable(
      v.object({
        primary: v.string(),
        secondary: v.string(),
      }),
    ),
    memberSince: v.string(),
  }),
});

export type PublicProfileDataParams = v.InferOutput<(typeof publicProfileDataRpcContract)["paramsSchema"]>;

export type PublicProfileDataResult = v.InferOutput<(typeof publicProfileDataRpcContract)["resultSchema"]>;
